<div class="w-[560px]">
  <!-- Header -->
  <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
    <div class="flex items-center gap-4">
      <div class="w-12 h-12 rounded-xl flex items-center justify-center"
           [ngClass]="{
             'bg-primary-100 dark:bg-primary-900/30': phase === 'loading' || phase === 'preview' || phase === 'processing',
             'bg-green-100 dark:bg-green-900/30': phase === 'result' && result?.success,
             'bg-red-100 dark:bg-red-900/30': phase === 'error' || (phase === 'result' && !result?.success)
           }">
        <mat-icon 
          [svgIcon]="phase === 'result' && result?.success ? 'tabler_outline:circle-check' : (phase === 'error' ? 'tabler_outline:alert-triangle' : 'tabler_outline:shield-check')"
          class="icon-size-6"
          [ngClass]="{
            'text-primary-600 dark:text-primary-400': phase === 'loading' || phase === 'preview' || phase === 'processing',
            'text-green-600 dark:text-green-400': phase === 'result' && result?.success,
            'text-red-600 dark:text-red-400': phase === 'error' || (phase === 'result' && !result?.success)
          }">
        </mat-icon>
      </div>
      <div>
        <h2 class="text-xl font-bold text-gray-900 dark:text-white">
          <ng-container *ngIf="phase === 'loading'">Ładowanie...</ng-container>
          <ng-container *ngIf="phase === 'preview'">Potwierdź realizację zamówienia</ng-container>
          <ng-container *ngIf="phase === 'processing'">Realizacja w toku...</ng-container>
          <ng-container *ngIf="phase === 'result'">Wynik realizacji</ng-container>
          <ng-container *ngIf="phase === 'error'">Błąd</ng-container>
        </h2>
        <p *ngIf="preview" class="text-sm text-gray-500 dark:text-gray-400 font-mono">{{ preview.order.orderNumber }}</p>
      </div>
    </div>
    <button mat-icon-button (click)="close(phase === 'result')">
      <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="p-6 max-h-[70vh] overflow-y-auto">

    <!-- PHASE: Loading -->
    <div *ngIf="phase === 'loading'" class="flex flex-col items-center justify-center py-12">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="mt-4 text-gray-500 dark:text-gray-400">Pobieranie podglądu realizacji...</p>
    </div>

    <!-- PHASE: Error -->
    <div *ngIf="phase === 'error'" class="flex flex-col items-center justify-center py-8">
      <div class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mb-4">
        <mat-icon [svgIcon]="'tabler_outline:alert-triangle'" class="text-red-500 icon-size-8"></mat-icon>
      </div>
      <p class="text-red-600 dark:text-red-400 font-medium text-center">{{ errorMessage }}</p>
    </div>

    <!-- PHASE: Preview -->
    <div *ngIf="phase === 'preview' && preview">
      
      <!-- Zmiana planu -->
      <div class="mb-6">
        <h4 class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">Zmiana subskrypcji</h4>
        
        <div class="flex items-center gap-4 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
          <!-- Obecny plan -->
          <div class="flex-1 text-center">
            <div class="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold mb-2"
                 [ngClass]="preview.currentSubscription ? getStageBgColor(preview.currentSubscription.stage) + ' ' + getStageColor(preview.currentSubscription.stage) : 'bg-gray-100 dark:bg-gray-700 text-gray-500'">
              {{ preview.currentSubscription ? getStageName(preview.currentSubscription.stage) : 'BRAK' }}
            </div>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ preview.currentSubscription ? formatDocumentLimit(preview.currentSubscription.documentLimit) : '-' }}
            </p>
            <p *ngIf="preview.currentSubscription && preview.currentSubscription.daysRemaining > 0" class="text-xs text-gray-400 dark:text-gray-500 mt-1">
              Pozostało {{ preview.currentSubscription.daysRemaining }} dni
            </p>
          </div>

          <!-- Strzałka -->
          <div class="flex-shrink-0">
            <mat-icon [svgIcon]="'tabler_outline:arrow-right'" 
                      class="icon-size-6"
                      [ngClass]="{
                        'text-green-500': preview.isUpgrade,
                        'text-amber-500': preview.isDowngrade,
                        'text-blue-500': !preview.isUpgrade && !preview.isDowngrade
                      }"></mat-icon>
          </div>

          <!-- Nowy plan -->
          <div class="flex-1 text-center">
            <div class="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold mb-2"
                 [ngClass]="getStageBgColor(preview.plan.stage) + ' ' + getStageColor(preview.plan.stage)">
              {{ getStageName(preview.plan.stage) }}
            </div>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ formatDocumentLimit(preview.newDocumentLimit) }}
            </p>
          </div>
        </div>

        <!-- Badge upgrade/downgrade -->
        <div *ngIf="preview.isUpgrade || preview.isDowngrade" class="mt-2 text-center">
          <span *ngIf="preview.isUpgrade" class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
            <mat-icon [svgIcon]="'tabler_outline:trending-up'" class="icon-size-3.5"></mat-icon>
            Upgrade — 50% pozostałych dni zostanie dodane
          </span>
          <span *ngIf="preview.isDowngrade" class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">
            <mat-icon [svgIcon]="'tabler_outline:trending-down'" class="icon-size-3.5"></mat-icon>
            Downgrade — 100% pozostałych dni zostanie dodane
          </span>
        </div>
      </div>

      <!-- Dni -->
      <div class="mb-6">
        <h4 class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">Obliczenie dni</h4>
        
        <div class="space-y-2 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
          <div class="flex justify-between text-sm">
            <span class="text-gray-600 dark:text-gray-400">Dni z planu ({{ preview.order.planName }})</span>
            <span class="font-medium text-gray-900 dark:text-white">{{ preview.daysFromPlan }} dni</span>
          </div>
          <div *ngIf="preview.bonusDays > 0" class="flex justify-between text-sm">
            <span class="text-green-600 dark:text-green-400">
              + Bonus ({{ preview.isUpgrade ? '50%' : '100%' }} z {{ preview.currentSubscription?.daysRemaining }} dni)
            </span>
            <span class="font-medium text-green-600 dark:text-green-400">+{{ preview.bonusDays }} dni</span>
          </div>
          <mat-divider></mat-divider>
          <div class="flex justify-between text-sm pt-1">
            <span class="font-bold text-gray-900 dark:text-white">Łącznie do przyznania</span>
            <span class="font-black text-primary-600 dark:text-primary-400 text-lg">{{ preview.totalDays }} dni</span>
          </div>
        </div>
      </div>

      <!-- Kwota -->
      <div class="mb-6 flex items-center justify-between p-3 rounded-lg bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
        <span class="text-sm text-gray-600 dark:text-gray-400">Kwota zamówienia</span>
        <span class="font-bold text-gray-900 dark:text-white">{{ formatPrice(preview.order.amount) }}</span>
      </div>

      <mat-divider class="my-6"></mat-divider>

      <!-- Opcje fulfillmentu -->
      <div>
        <h4 class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">Opcje realizacji</h4>
        
        <div class="space-y-2">
          <mat-checkbox [(ngModel)]="skipInvoice" color="primary">
            <span class="text-sm text-gray-700 dark:text-gray-300">Pomiń generowanie faktury</span>
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="skipEmail" color="primary">
            <span class="text-sm text-gray-700 dark:text-gray-300">Pomiń wysyłkę e-mail</span>
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="skipNotification" color="primary">
            <span class="text-sm text-gray-700 dark:text-gray-300">Pomiń powiadomienie w aplikacji</span>
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="skipDiscord" color="primary">
            <span class="text-sm text-gray-700 dark:text-gray-300">Pomiń Discord</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- PHASE: Processing -->
    <div *ngIf="phase === 'processing'" class="flex flex-col items-center justify-center py-12">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="mt-4 text-gray-500 dark:text-gray-400">Realizowanie zamówienia...</p>
    </div>

    <!-- PHASE: Result -->
    <div *ngIf="phase === 'result' && result">
      
      <!-- Ogólny status -->
      <div class="mb-6 p-4 rounded-xl border"
           [ngClass]="{
             'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800': result.success,
             'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800': !result.success
           }">
        <div class="flex items-center gap-3">
          <mat-icon 
            [svgIcon]="result.success ? 'tabler_outline:circle-check' : 'tabler_outline:alert-triangle'"
            class="icon-size-6"
            [ngClass]="result.success ? 'text-green-600' : 'text-red-600'"></mat-icon>
          <div>
            <p class="font-semibold" [ngClass]="result.success ? 'text-green-700 dark:text-green-400' : 'text-red-700 dark:text-red-400'">
              {{ result.success ? 'Zamówienie zrealizowane pomyślnie' : 'Realizacja nie powiodła się w pełni' }}
            </p>
            <p *ngIf="result.daysGranted > 0" class="text-sm" [ngClass]="result.success ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">
              Przyznano {{ result.daysGranted }} dni
              <span *ngIf="result.bonusDays > 0">(w tym {{ result.bonusDays }} dni bonusu)</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Checklist -->
      <div class="space-y-3">
        <h4 class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">Status operacji</h4>

        <!-- Subskrypcja -->
        <div class="flex items-center gap-3 p-3 rounded-lg" 
             [ngClass]="result.subscriptionActivated ? 'bg-green-50 dark:bg-green-900/20' : 'bg-red-50 dark:bg-red-900/20'">
          <mat-icon 
            [svgIcon]="result.subscriptionActivated ? 'tabler_outline:circle-check' : 'tabler_outline:circle-x'"
            class="icon-size-5 flex-shrink-0"
            [ngClass]="result.subscriptionActivated ? 'text-green-600 dark:text-green-400' : 'text-red-500 dark:text-red-400'"></mat-icon>
          <div class="flex-1">
            <p class="text-sm font-medium" [ngClass]="result.subscriptionActivated ? 'text-green-700 dark:text-green-300' : 'text-red-700 dark:text-red-300'">
              Subskrypcja aktywowana
            </p>
            <p *ngIf="result.subscriptionError" class="text-xs text-red-500 dark:text-red-400">{{ result.subscriptionError }}</p>
            <p *ngIf="result.subscriptionActivated && result.newPlan" class="text-xs text-green-600 dark:text-green-400">
              {{ getStageName(result.newPlan.stage) }} — ważna do {{ formatDate(result.newPlan.validUntil) }}
            </p>
          </div>
        </div>

        <!-- Faktura -->
        <div class="flex items-center gap-3 p-3 rounded-lg"
             [ngClass]="{
               'bg-green-50 dark:bg-green-900/20': result.invoiceGenerated,
               'bg-red-50 dark:bg-red-900/20': !result.invoiceGenerated && result.invoiceError,
               'bg-gray-50 dark:bg-gray-800': !result.invoiceGenerated && !result.invoiceError
             }">
          <mat-icon 
            [svgIcon]="result.invoiceGenerated ? 'tabler_outline:circle-check' : (result.invoiceError ? 'tabler_outline:circle-x' : 'tabler_outline:circle-minus')"
            class="icon-size-5 flex-shrink-0"
            [ngClass]="{
              'text-green-600 dark:text-green-400': result.invoiceGenerated,
              'text-red-500 dark:text-red-400': !result.invoiceGenerated && result.invoiceError,
              'text-gray-400': !result.invoiceGenerated && !result.invoiceError
            }"></mat-icon>
          <div class="flex-1">
            <p class="text-sm font-medium"
               [ngClass]="{
                 'text-green-700 dark:text-green-300': result.invoiceGenerated,
                 'text-red-700 dark:text-red-300': !result.invoiceGenerated && result.invoiceError,
                 'text-gray-500': !result.invoiceGenerated && !result.invoiceError
               }">
              Faktura VAT
              <span *ngIf="result.invoiceGenerated && result.invoiceNumber" class="font-normal"> — {{ result.invoiceNumber }}</span>
              <span *ngIf="!result.invoiceGenerated && !result.invoiceError" class="font-normal"> — pominięto</span>
            </p>
            <p *ngIf="result.invoiceError" class="text-xs text-red-500 dark:text-red-400">{{ result.invoiceError }}</p>
            <p *ngIf="result.gusWarning" class="text-xs text-amber-500 dark:text-amber-400">⚠️ {{ result.gusWarning }}</p>
          </div>
        </div>

        <!-- Email -->
        <div class="flex items-center gap-3 p-3 rounded-lg"
             [ngClass]="{
               'bg-green-50 dark:bg-green-900/20': result.emailSent,
               'bg-red-50 dark:bg-red-900/20': !result.emailSent && result.emailError,
               'bg-gray-50 dark:bg-gray-800': !result.emailSent && !result.emailError
             }">
          <mat-icon 
            [svgIcon]="result.emailSent ? 'tabler_outline:circle-check' : (result.emailError ? 'tabler_outline:circle-x' : 'tabler_outline:circle-minus')"
            class="icon-size-5 flex-shrink-0"
            [ngClass]="{
              'text-green-600 dark:text-green-400': result.emailSent,
              'text-red-500 dark:text-red-400': !result.emailSent && result.emailError,
              'text-gray-400': !result.emailSent && !result.emailError
            }"></mat-icon>
          <div class="flex-1">
            <p class="text-sm font-medium"
               [ngClass]="{
                 'text-green-700 dark:text-green-300': result.emailSent,
                 'text-red-700 dark:text-red-300': !result.emailSent && result.emailError,
                 'text-gray-500': !result.emailSent && !result.emailError
               }">
              Wiadomość e-mail
              <span *ngIf="!result.emailSent && !result.emailError" class="font-normal"> — pominięto</span>
            </p>
            <p *ngIf="result.emailError" class="text-xs text-red-500 dark:text-red-400">{{ result.emailError }}</p>
          </div>
        </div>

        <!-- Powiadomienie -->
        <div class="flex items-center gap-3 p-3 rounded-lg"
             [ngClass]="{
               'bg-green-50 dark:bg-green-900/20': result.notificationSent,
               'bg-red-50 dark:bg-red-900/20': !result.notificationSent && result.notificationError,
               'bg-gray-50 dark:bg-gray-800': !result.notificationSent && !result.notificationError
             }">
          <mat-icon 
            [svgIcon]="result.notificationSent ? 'tabler_outline:circle-check' : (result.notificationError ? 'tabler_outline:circle-x' : 'tabler_outline:circle-minus')"
            class="icon-size-5 flex-shrink-0"
            [ngClass]="{
              'text-green-600 dark:text-green-400': result.notificationSent,
              'text-red-500 dark:text-red-400': !result.notificationSent && result.notificationError,
              'text-gray-400': !result.notificationSent && !result.notificationError
            }"></mat-icon>
          <div class="flex-1">
            <p class="text-sm font-medium"
               [ngClass]="{
                 'text-green-700 dark:text-green-300': result.notificationSent,
                 'text-red-700 dark:text-red-300': !result.notificationSent && result.notificationError,
                 'text-gray-500': !result.notificationSent && !result.notificationError
               }">
              Powiadomienie w aplikacji
              <span *ngIf="!result.notificationSent && !result.notificationError" class="font-normal"> — pominięto</span>
            </p>
            <p *ngIf="result.notificationError" class="text-xs text-red-500 dark:text-red-400">{{ result.notificationError }}</p>
          </div>
        </div>

        <!-- Discord -->
        <div class="flex items-center gap-3 p-3 rounded-lg"
             [ngClass]="{
               'bg-green-50 dark:bg-green-900/20': result.discordSent,
               'bg-red-50 dark:bg-red-900/20': !result.discordSent && result.discordError,
               'bg-gray-50 dark:bg-gray-800': !result.discordSent && !result.discordError
             }">
          <mat-icon 
            [svgIcon]="result.discordSent ? 'tabler_outline:circle-check' : (result.discordError ? 'tabler_outline:circle-x' : 'tabler_outline:circle-minus')"
            class="icon-size-5 flex-shrink-0"
            [ngClass]="{
              'text-green-600 dark:text-green-400': result.discordSent,
              'text-red-500 dark:text-red-400': !result.discordSent && result.discordError,
              'text-gray-400': !result.discordSent && !result.discordError
            }"></mat-icon>
          <div class="flex-1">
            <p class="text-sm font-medium"
               [ngClass]="{
                 'text-green-700 dark:text-green-300': result.discordSent,
                 'text-red-700 dark:text-red-300': !result.discordSent && result.discordError,
                 'text-gray-500': !result.discordSent && !result.discordError
               }">
              Discord
              <span *ngIf="!result.discordSent && !result.discordError" class="font-normal"> — pominięto</span>
            </p>
            <p *ngIf="result.discordError" class="text-xs text-red-500 dark:text-red-400">{{ result.discordError }}</p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Footer -->
  <div class="p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
    <div class="flex items-center justify-between">
      <!-- Preview -->
      <ng-container *ngIf="phase === 'preview'">
        <button mat-stroked-button (click)="close()">Anuluj</button>
        <button 
          mat-flat-button 
          color="primary"
          (click)="confirmFulfillment()">
          <mat-icon [svgIcon]="'tabler_outline:check'" class="mr-2"></mat-icon>
          Potwierdź realizację
        </button>
      </ng-container>

      <!-- Result / Error -->
      <ng-container *ngIf="phase === 'result' || phase === 'error'">
        <div></div>
        <button mat-flat-button color="primary" (click)="close(phase === 'result')">
          Zamknij
        </button>
      </ng-container>

      <!-- Loading / Processing -->
      <ng-container *ngIf="phase === 'loading' || phase === 'processing'">
        <div></div>
        <button mat-stroked-button disabled>
          <mat-spinner diameter="18" class="mr-2"></mat-spinner>
          {{ phase === 'loading' ? 'Ładowanie...' : 'Realizowanie...' }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
